import React, { useEffect } from "react";
import { useAuth } from '../contexts/AuthContext';
import formattedDate from '../utils/formattedDate';
import { toast } from 'react-toastify';
import Datastudio from "./Datastudio";
import InvoiceToast from "../components/common/InvoiceToast";
import PowerBi from "./PowerBi";

const Z21Overview = () => {
  const { currentUser } = useAuth();

  const notifyInvoices = (invoices) => {
    if(invoices.length > 0) {
      invoices.forEach(invoice => {
        const dueDate = formattedDate(invoice.invoice_date.seconds);
        toast.error(`UNPAID - Invoice ${invoice.invoice_id} due on ${dueDate}`);
      })
    }else{
      console.log("No invoices found")
    }
  }

  useEffect(() => {
    // Looks in localstorage for "hasVisited key, if it's true, hasVisitedPage set to true, otherwise, false (i.e.: null)"
    const hasVisitedPage = () => {
      return  localStorage.getItem("hasVisited") === 'true' ? true : false; 
    }
    // Sets localStorage key "hasVisited" to true
    const visitPage = () => {
      localStorage.setItem("hasVisited", true)
    }
    // If hasVisitedPage is false, AND there are invoices for the current user, trigger visitPage()
    // Then, notify the user of current invoices using react-toastify
    if (!hasVisitedPage() && currentUser.invoices) {
      visitPage()
      notifyInvoices(currentUser.invoices)
    }
  }, [])

  return (
    <>
      <PowerBi title="Dashboard Overview" resource="overview" />
      <InvoiceToast currentUser={currentUser} />
    </>
  );
}

export default Z21Overview;